import { Translation } from 'cng-common/features/translations'
import { Tag } from 'partner360/components/qualityIndicator'

import { TRANSLATION_KEYS } from '../../../../configs/translations'

import styles from './FinancialPlanScoreInfo.module.scss'

export const FinancialPlanScoreInfo = () => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Translation text={TRANSLATION_KEYS.quality.scoreInfo.title} />
      </div>

      <p className={styles.description}>
        <Translation htmlAvailable text={TRANSLATION_KEYS.quality.scoreInfo.description} />
      </p>

      <div className={styles.tags}>
        <Tag variant={'Low'} translation={TRANSLATION_KEYS.quality.scoreInfo.low} />
        <Tag variant={'Moderate'} translation={TRANSLATION_KEYS.quality.scoreInfo.moderate} />
        <Tag variant={'High'} translation={TRANSLATION_KEYS.quality.scoreInfo.high} />
      </div>
    </div>
  )
}
